import React, {useEffect, useState} from "react";
import {FIREBASE_SCREEN_NAMES, LOCALSTORAGE_ITEMS} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import {FormattedMessage} from "react-intl";
import backImg from "../../assets/img/icon_back.svg";
import 'react-calendar/dist/Calendar.css';
import ReservationActionsBar from "../../components/Actionsbar/ReservationActionsBar";
import * as ReservationService from "../../services/ReservationService";
import {resetTime} from "../../util/common";
import {DATE_FORMAT} from "../../util/DateUtil";
import Moment from "react-moment";
import {PATH} from "../../routes/routes.js";
import {EventBus} from "../../util/EventBus";
import analyticsLogEvent from "../../services/FirebaseService";
import CookiesBanner from "../../components/Banner/CookiesBanner";
import {useNavigate} from "react-router";


function AllReservations() {
    const navigateTo = useNavigate();
    const today = new Date();
    const tomorrow = resetTime(new Date());
    tomorrow.setDate(tomorrow.getDate() + 1);
    const backButtonEnabled = StorageService.getItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON) === "true";
    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        allReservations: {},
        shopDetails: null
    });

    useEffect(() => {
        getPageContent().then(r=>{
            analyticsLogEvent("screen_view", {
                firebase_screen: FIREBASE_SCREEN_NAMES.ALL_RESERVATIONS,
                firebase_screen_class: FIREBASE_SCREEN_NAMES.ALL_RESERVATIONS
            });
        });

    }, []);

    //todo check if this approach works
    useEffect(() => {

        const handlePopstate = () => {
            if (window.history.state && window.history.state.action === 'POP') {
                if (backButtonEnabled) {
                    navigateTo(PATH.MAIN);
                } else {
                    navigateTo(PATH.ALL_RESERVATIONS);
                }
            }
        };

        window.addEventListener('popstate', handlePopstate);

        return () => {
            window.removeEventListener('popstate', handlePopstate);
        };
    }, [navigateTo, backButtonEnabled]);


    const getPageContent = async () => {
        if ((StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) && StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL)) {
            await getAllReservations().then(response => {

                if (response.count === 0) {
                    StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_RESERVATIONS, "false");
                    navigateTo(PATH.CREATE_RESERVATION);
                } else {
                    StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_RESERVATIONS, "true");
                }

                setState({
                    ...state,
                    shopDetails: JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)),
                    allReservations: response.reservations
                })
            });
        }else  if ((StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) && !StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL)) {
            navigateTo(PATH.CREATE_RESERVATION);
            setState({
                ...state,
                shopDetails: JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)),
                allReservations: []
            })
        }
    }

    const toReservationDetailsPage = (rid) => {
        navigateTo(PATH.RESERVATION_DETAILS + "/" + rid)
    }
    const toCreateReservationPage = () => {
        navigateTo(PATH.CREATE_RESERVATION);
    }

    const getAllReservations = async () => {
        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            // "fromDate": "2025-10-28T09:07:54.182Z" // dummy date in order to test empty reservation array
            // "toDate": null,
            // "createdFromDate": null,
            // "createdToDate" : null,
            // "procStatuses":  null
        }

        const response = await ReservationService.getAllReservations(body);
        if (response.ok) {

        } else {
            EventBus.dispatch("genericErrorMsg");
            console.log("Error retrieving all reservations");
        }
        return response.data;
    }

    const goBack = () => {
        if (backButtonEnabled) {
            navigateTo(PATH.MAIN);
        }else{
            navigateTo(PATH.ALL_RESERVATIONS);
        }
    }

    const getTodayOrTomorrowStringFromDate = (obj) => {
        var miliseconsPassedFrom70 = Date.parse(obj.date);
        var dateObj = new Date();
        dateObj.setTime(miliseconsPassedFrom70);

        if (resetTime(today).getTime() === resetTime(dateObj).getTime()) {
            return <FormattedMessage id="Today"/>;
        }
       else  if (resetTime(tomorrow).getTime() === resetTime(dateObj).getTime()) {
            return <FormattedMessage id="Tomorrow"/>;
        }else {
            return <Moment
                format={DATE_FORMAT.DAY_MONTH_YEAR_MOBILE_VERSION}
                date={dateObj}
            />
        }
    }


    return (
        <>
            <CookiesBanner/>
            {state.shopDetails?.merchantConfig &&
          <>

                <header className="common-header no-bg">
                    {backButtonEnabled && <a className="btn-back" onClick={goBack}><img alt="back icon" src={backImg}/></a>}
                    {state.shopDetails?.title && <h2 className="row title"><FormattedMessage id="Reservations"/></h2>}
                </header>

              <div className="inner-content">
               <section className="all-reservation-cards">
                   {state.allReservations?.length > 0 ?
                       state.allReservations?.map((reservation, index) => (
                           <div data-qa="reservation-card" onClick={() => toReservationDetailsPage(reservation.rid)} key={"productIndex"+ index} className="reservation-card">
                               <div className="row">
                                   <div className="col shop-name-col title">
                                       {state.shopDetails?.title}
                                   </div>
                                   <div className="col num-of-people-col title">
                                       <FormattedMessage id="People"/> &nbsp; {reservation.guestsNr}
                                   </div>
                               </div>
                               <div className="row">
                                   <div className="col day-col">
                                       {getTodayOrTomorrowStringFromDate(reservation)}
                                   </div>
                                   <div className="col hour-col">
                                       <Moment
                                           format={DATE_FORMAT.HOUR_MINUTES}
                                           date={reservation.date}
                                       />
                                   </div>
                               </div>
                               <div className="row">
                                   <div className={"col status-col" + " " + reservation.procStatus.toLowerCase()}>
                                       {reservation.procStatus === "NEW"? <FormattedMessage id="NewRequest"/>: reservation.procStatus }
                                   </div>
                               </div>
                           </div>
                       ))
                   :
                       <FormattedMessage id="NoReservationsYet"/>
                   }

               </section>
              </div>
          </>
            }

            <ReservationActionsBar
                buttonName={<FormattedMessage id="NewReservation"/>}
                btnClassName={"btn btn-success btn-xl"}
                buttonAction={() => toCreateReservationPage()}
            />

        </>
    );
}

export default AllReservations;
